import type { AccountType, AzureEnvironment } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { repository } from "~/clientInstance";
import { PlatformHubEditAccountPage } from "./PlatformHubEditAccountPage";
interface PlatformHubAccountsPageProps {
    accountType: AccountType;
    azureEnvironments: AzureEnvironment[];
}
interface LoaderData {
    azureEnvironments: AzureEnvironment[];
}
export async function platformHubAddAccountPageLoader(): Promise<LoaderData> {
    const azureEnvironments = await repository.Accounts.getIsolatedAzureEnvironments();
    return {
        azureEnvironments,
    };
}
export function PlatformHubAddAccountPage({ accountType, azureEnvironments }: PlatformHubAccountsPageProps) {
    const loaderData = {
        azureEnvironments,
        accountType,
    };
    return <PlatformHubEditAccountPage loaderData={loaderData}/>;
}
